module.exports = __webpack_public_path__ + "img/oneList2.9e023762.png";